import type { Step } from "react-joyride";

export const qcDetailTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າລາຍລະອຽດມາດຕະຖານ QC! ຫນ້ານີ້ຈະສະແດງຂໍ້ມູນທັງໝົດຂອງມາດຕະຖານ QC. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="detail-header"]',
    content:
      "ນີ້ແມ່ນສ່ວນ header. ທ່ານສາມາດກັບໄປຫນ້າລາຍການ QC ດ້ວຍປຸ່ມ 'ກັບ', ເບິ່ງ PDF Preview ດ້ວຍປຸ່ມ 'ເບິ່ງ PDF Preview', ບັນທຶກຜົນກວດ QC ດ້ວຍປຸ່ມ 'ບັນທຶກຜົນກວດ QC', ຫຼືແກ້ໄຂມາດຕະຖານ QC ນີ້ດ້ວຍປຸ່ມ 'ແກ້ໄຂ' (ຖ້າທ່ານມີສິດແກ້ໄຂ).",
    placement: "bottom",
  },
  {
    target: '[data-tourid="detail-basic-info"]',
    content:
      "ນີ້ແມ່ນຂໍ້ມູນພື້ນຖານຂອງມາດຕະຖານ QC. ທ່ານຈະເຫັນຊື່, ຄຳອະທິບາຍ, ປະເພດງານ, ຂັ້ນຕອນການດຳເນີນງານ, ພະແນກ, ຜູ້ກວດສອບ, ວັນທີອັບເດດລ່າສຸດ, ແລະສະຖານະ (ໃຊ້ງານ/ປັບປຸງ/ເລີກໃຊ້) ຂອງມາດຕະຖານ QC ນີ້.",
    placement: "top",
  },
  {
    target: '[data-tourid="detail-items"]',
    content:
      "ນີ້ແມ່ນພາກລາຍການກວດສອບ. ທ່ານຈະເຫັນລາຍການກວດສອບທັງໝົດທີ່ກຳນົດໃນມາດຕະຖານ QC ນີ້. ສຳລັບແຕ່ລະລາຍການ, ທ່ານຈະເຫັນຊື່, ຄຳອະທິບາຍ, ເກນຜ່ານ, ເກນບໍ່ຜ່ານ, ແລະສະຖານະວ່າຈຳເປັນຫຼືບໍ່.",
    placement: "top",
  },
  {
    target: '[data-tourid="detail-criteria"]',
    content:
      "ນີ້ແມ່ນພາກເກນຜ່ານ / ບໍ່ຜ່ານ. ທ່ານຈະເຫັນເກນການຜ່ານແລະເກນການບໍ່ຜ່ານທີ່ກຳນົດໃນມາດຕະຖານ QC ນີ້. ເກນເຫຼົ່ານີ້ຈະຖືກໃຊ້ໃນການປະເມີນຜົນການກວດ QC.",
    placement: "top",
  },
  {
    target: '[data-tourid="detail-action-on-fail"]',
    content:
      "ນີ້ແມ່ນພາກແນວທາງເມື່ອບໍ່ຜ່ານ. ທ່ານຈະເຫັນຂໍ້ມູນກ່ຽວກັບສິ່ງທີ່ຄວນທຳເມື່ອຜົນການກວດ QC ບໍ່ຜ່ານ, ຕຳແໜ່ງທີ່ຕ້ອງຮັບແຈ້ງ, ແລະການຕັ້ງຄ່າອື່ນໆ ເຊັ່ນ ຕ້ອງມີຮູບພາບ ຫຼື ຕ້ອງມີໝາຍເຫດ.",
    placement: "top",
  },
  {
    target: '[data-tourid="detail-mapping"]',
    content:
      "ນີ້ແມ່ນພາກການຜູກມັດ (Mapping). ທ່ານຈະເຫັນ Checklist ແລະ KPI ທີ່ຜູກມັດກັບມາດຕະຖານ QC ນີ້ (ຖ້າມີ). ການຜູກມັດນີ້ຈະຊ່ວຍໃຫ້ສາມາດຈັດການການກວດສອບກັບ Checklist ແລະນຳຜົນການກວດ QC ໄປໃຊ້ໃນການຄິດໄລ່ KPI ໄດ້.",
    placement: "top",
  },
];
